export default __webpack_public_path__ + "static/media/external-link.9a540671.svg";